<template>
	<div>
		<a-modal id='warp_sim12' width='40rem' v-model="visible" on-ok="handleOk1"
		v-dragModal
		:dialog-style="{ top: '10vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div v-if='land == "eng"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;font-size: .85rem;">
					Welcome to our online trading system
				</div>
				<div v-else
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;font-size: .85rem;">
					歡迎使用本公司網上交易系統
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 40px;">
					<pre v-if='land == "eng"' class='myfonts'>Investment involves risks, and the price of a security may move up or down, or even become worthless. Investors should read the relevant risk disclosure statements and related documents before making any investment decisions. Investors should note that investing products involves different risks (including but not limited to currency risk, exchange rate risk, issuer/transaction credit risk, interest rate risk, liquidity risk, etc. (if applicable). The main risks of investing in Shanghai stock exchanges include:
• The Hong Kong Investor Compensation Fund does not cover any Northbound and Southbound transactions under Shanghai-Hong Kong Stock Connect.
• When the relevant limit is exhausted, the transaction will be restricted or suspended.
• Shanghai-Hong Kong Stock Connect is only a trading day in both cities, and the banks in the two markets will only open when the corresponding payment date is open. Investors should pay attention to the opening date of Shanghai-Hong Kong Stock Connect and decide whether or not to bear the risk of stock price fluctuations during the period of Shanghai-Hong Kong Stock Connect's non-trading due to its own risk-taking ability.
• When a number of stocks are transferred out of the Shanghai-Hong Kong Stock Connect, the stock can only be sold and cannot be bought.
• If you want to convert your local currency into RMB, you will be subject to exchange rate risk.</pre>
					<pre v-else  class='myfonts'>投 資 涉 及 風 險 ， 證 券 價 格 可 升 可 跌 ， 甚 至 變 成 毫 無 價 值 。 投 資 者 在 作 出 任 何 投 資 決 定 前 ， 應 詳 細 閱 讀 有 關 之 風 險 披 露 聲 明 及 相 關 文 件 。 投 資 者 應 注 意 投 資 產 品 涉 及 不 同 風 險 ( 包 括 但 不 限 於 貨 幣 風 險 、 匯 率 風 險 、 發 行 人 / 交 易 對 手 之 信 貸 風 險 、 利 率 風 險 、 流 動 資 金 風 險 等 ( 如 適 用 )) 。 投 資 滬 股 通 股 票 的 主 要 風 險 包 括 ：
• 香 港 的 投 資 者 賠 償 基 金 並 不 涵 蓋 滬 港 通 下 的 任 何 北 向 交 易 和 南 向 交 易 。
• 當 有 關 額 度 用 盡 時 ， 交 易 將 會 受 到 限 制 或 被 暫 停 。
• 滬 港 通 只 有 在 兩 地 市 場 均 為 交 易 日 ， 而 且 兩 地 市 場 的 銀 行 在 相 應 的 款 項 交 收 日 均 開 放 時 才 會 開 放 。 投 資 者 應 該 注 意 滬 港 通 的 開 放 日 期 ， 並 因 應 自 身 的 風 險 承 受 能 力 決 定 是 否 在 滬 港 通 不 交 易 的 期 間 承 擔 股 票 價 格 波 動 的 風 險 。
• 當 一 些 股 票 被 調 出 滬 港 通 範 圍 時 ， 該 股 票 只 能 被 賣 出 而 不 能 被 買 入 。
• 若 要 將 本 地 貨 幣 轉 換 為 人 民 幣 作 投 資 ， 將 需 承 受 匯 率 風 險 。</pre>
				</div>
				<div style="text-align: center;margin: 2.1rem 0 1.1rem;">
					<button class='btn1 btnx' @click='handbect("form")' v-html='"同&nbsp;&nbsp;&nbsp;&nbsp;意"'></button>
					<button class='btn1 btn2' @click='resetForm("form")'>不同意</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		data() {
			return {
				loading:true,
				visible: true,
				form: {
					cal: "",
					cn_name: "",
					en_name: "",
					inviter: '',
					khcreatedate: "", //创建时间
					nationcode: "",
					phonenum: "",
					revisit_duration: '',
					revisit_remark: '',
					revisitLogList: [],
					step_datetime: ''
				},
			}
		},
		mounted() {
			// this.handz()
			// window.addEventListener('')
		},
		methods: {
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getRevis,
					data: {
				
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(ruleForm) {
				// if(this.loading){
					// this.loading = false
				// this.$refs[ruleForm].resetFields();
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.form.token = this.$store.state.token;
						this.form.cancelflag = 1
						this.$ajax({
							method: 'post',
							url: this.$api.setedit,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
						} else {
								console.log('error submit!!');
								return false;
							}
						});
				// }
			},
			//下单
			handbect(ruleForm) {
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						// this.form.expire_date = this.form.expire_date._d ? App.oDate.secsTime3(this.form.expire_date._d) : this.form.expire_date;
						this.form.token = this.$store.state.token;
						this.form.flag = "domainname";
						this.$ajax({
							method: 'post',
							url: this.$api.setedit,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	 #warp_sim12 .myfonts{
		font-family: '微軟正黑體, sans-serif';font-size: .75rem;
		    white-space: pre-wrap !important; line-height: 35px;
		    white-space: -moz-pre-wrap;
		    white-space: -pre-wrap;
		    white-space: -o-pre-wrap;
		    word-wrap: break-word;
		    overflow: hidden;
		    color: #000;
	}
	#warp_sim12 .ant-modal-header,
	#warp_sim12 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#warp_sim12 {
		.ant-radio-wrapper{
			display: flex;
			align-items: center;
		}
		.ant-form-explain {
			display: none;
		}

		.ant-modal {
			// top: 15vh;
		}

		.ant-col-12 {
			text-align: right;
		}
		.myleft{
			text-align: left;
		}
		.ant-form-item-label {
			width: 30%;
		}

		.ant-form-item,
		.ant-form-item-control {
			width: 100%;

			.ant-calendar-picker {
				width: 100%;
			}

		}

		.ant-radio-group-default {
			width: 100%;
			margin-top: .3rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: .8rem;
			}
		}

		.ant-form-item-control-wrapper {
			width: 70%;

			.ant-form-item-control {
				width: 100%;
			}
		}

		#lastname {
			text-align: right;

			.ant-form-item-label {
				width: 10%;
			}

			.ant-form-item-control-wrapper {
				width: 86%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
			padding-bottom: 1px;
		}

		.btn1 {
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #bbbbbb;
		}

		.mydivs {
			max-height: 7rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
			
			.c {
				font-size: .8rem;
			}

			.f {
				// text-align: right;
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}
	}
	// @media screen and(min-width: 1921px){
	// 	#warp_sim12 {
	// 		.ant-modal-close-x {
	// 			.anticon svg {
	// 				top: 1.5rem !important;
	// 			}
	// 		}
	// 	}
	// }.ant-modal-close-x {
	// 		.anticon svg {
	// 			color: #5cb1b9;
	// 			position: relative;
	// 			top: .7rem;
	// 			right: 1rem;
	// 		}
	// 	}
</style>
